import { darkThemeColors as colors } from '../colors/themeColors';
import { TDropdowns } from './TDropdown';

export const darkThemeDropdowns: TDropdowns = {
  variants: {
    default: {
      enabled: {
        // default
        fontColor: colors.textPrimarySecondary1100,
        iconColor: colors.iconIconPrimaryPressedSecondary2100,
        background: colors.backgroundPrimaryWhite,
        border: `1px solid ${colors.strokePrimaryGrey20}`,
        borderRadius: '8px',
        padding: '4px 0',
        dropdownItemPadding: '4px 16px',

        // hover
        dropdownItemBackgroundHover: colors.backgroundInteractionActiveGrey20,

        // active
        dropdownItemBackgroundActive: colors.backgroundInteractionPressedSecondary4100,
      },
      disabled: {
        fontColor: colors.textSecondarySubtleGrey80,
        iconColor: colors.iconIconInactiveSecondary240,
        background: colors.backgroundPrimaryWhite,
        border: `1px solid ${colors.strokePrimaryGrey20}`,
        borderRadius: '8px',
        padding: '4px 0',
        dropdownItemPadding: '4px 16px',

        // hover
        dropdownItemBackgroundHover: colors.backgroundPrimaryWhite,

        // active
        dropdownItemBackgroundActive: colors.backgroundPrimaryWhite,
      },
      error: {
        background: colors.backgroundPrimaryWhite,
        iconColor: colors.iconIconPrimaryPressedSecondary2100,
        border: `1px solid ${colors.strokeSystemErrorFunction1100}`,
        hintFontColor: colors.textSystemErrorFunction1100,
        fontColor: colors.textPrimarySecondary1100,
        borderRadius: '8px',
        padding: '4px 0',
        dropdownItemPadding: '4px 16px',
        // hover
        dropdownItemBackgroundHover: colors.backgroundInteractionActiveGrey20,

        // active
        dropdownItemBackgroundActive: colors.backgroundInteractionPressedSecondary4100,
      },
    },
    secondary: {
      enabled: {
        // default
        fontColor: colors.textPrimarySecondary1100,
        iconColor: colors.iconIconPrimaryPressedSecondary2100,
        background: colors.backgroundPrimaryWhite,
        border: `1px solid ${colors.strokePrimaryGrey20}`,
        borderRadius: '8px',
        padding: '4px 0',
        dropdownItemPadding: '8px 36px',

        // hover
        dropdownItemBackgroundHover: colors.backgroundInteractionActiveGrey20,

        // active
        dropdownItemBackgroundActive: colors.backgroundInteractionPressedSecondary4100,
      },
      disabled: {
        fontColor: colors.textSecondarySubtleGrey80,
        iconColor: colors.iconIconInactiveSecondary240,
        background: colors.backgroundPrimaryWhite,
        border: `1px solid ${colors.strokePrimaryGrey20}`,
        borderRadius: '8px',
        padding: '4px 0',
        dropdownItemPadding: '8px 36px',

        // hover
        dropdownItemBackgroundHover: colors.backgroundPrimaryWhite,

        // active
        dropdownItemBackgroundActive: colors.backgroundPrimaryWhite,
      },
      error: {
        // default
        fontColor: colors.textInverseWhite,
        iconColor: colors.iconIconInverseWhite,
        background: colors.backgroundAccentBlueStrongestSecondary1100,
        border: 'none',
        borderRadius: '0',
        padding: '4px 0',
        dropdownItemPadding: '4px 16px',

        // hover
        dropdownItemBackgroundHover: 'rgba(0,0,0,.05)',

        // active
        dropdownItemBackgroundActive: 'rgba(0,0,0,.05)',
      },
    },
  },
};

export default darkThemeDropdowns;
